var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrayCrossR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.9998 7.16634L1.91646 11.2497C1.76369 11.4025 1.56924 11.4788 1.33313 11.4788C1.09702 11.4788 0.902574 11.4025 0.749796 11.2497C0.597018 11.0969 0.52063 10.9025 0.52063 10.6663C0.52063 10.4302 0.597018 10.2358 0.749796 10.083L4.83313 5.99967L0.749796 1.91634C0.597018 1.76356 0.52063 1.56912 0.52063 1.33301C0.52063 1.0969 0.597018 0.902452 0.749796 0.749674C0.902574 0.596896 1.09702 0.520508 1.33313 0.520508C1.56924 0.520508 1.76369 0.596896 1.91646 0.749674L5.9998 4.83301L10.0831 0.749674C10.2359 0.596896 10.4304 0.520508 10.6665 0.520508C10.9026 0.520508 11.097 0.596896 11.2498 0.749674C11.4026 0.902452 11.479 1.0969 11.479 1.33301C11.479 1.56912 11.4026 1.76356 11.2498 1.91634L7.16646 5.99967L11.2498 10.083C11.4026 10.2358 11.479 10.4302 11.479 10.6663C11.479 10.9025 11.4026 11.0969 11.2498 11.2497C11.097 11.4025 10.9026 11.4788 10.6665 11.4788C10.4304 11.4788 10.2359 11.4025 10.0831 11.2497L5.9998 7.16634Z",
  fill: "#171717",
  fillOpacity: 0.5
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrayCrossR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gray-cross-r.138fe2096f0df08689328b80d63ad34d.svg";